module.exports = __webpack_public_path__ + "img/63.6.CODm.3655a5f9.png";